document.addEventListener('DOMContentLoaded', ()=>{
    new Swiper('.HH-FtbrandiconOUTr.swiper', {
        spaceBetween: 0, centeredSlides: true, speed: 6000,
        autoplay: { delay: 1 },
        loop: true,
        slidesPerView:'auto'
    });

    let ScrollTargetPDP = document.querySelectorAll(".Dsrgyu");
    ScrollTargetPDP.forEach((evt)=>{
        evt.addEventListener('click', (target)=>{
        target.preventDefault();
            if(window.innerWidth > 769){
                var targetElement = document.querySelector('#shopnowscroll');
                window.scrollTo({
                    top: targetElement.offsetTop - 91,
                    behavior: 'smooth'
                });
            }else{
                var targetElement = document.querySelector('#shopnowscroll');
                window.scrollTo({
                    top: targetElement.offsetTop - 120,
                    behavior: 'smooth'
                });
            }  
        })
    });  
    
    document.querySelectorAll("[js-flipped-column]").forEach(item => {
        if (!item.querySelector(".expertFace.expertBack")) return
        item.addEventListener("click", () => {
            item.classList.toggle("is-flipped")
        })
    })

    const more = document.querySelectorAll(".has__mor_option");
    const buttons = document.querySelectorAll(".many_more_yup");
    buttons.forEach(btn => btn.addEventListener("click", () => {
        more.forEach(el => {
            el.classList.toggle("open");
            if (el.classList.contains("open")) {
                el.style.maxHeight = el.scrollHeight + "px";
            } else {
                el.style.maxHeight = "0px";
            }
        });
        const isOpen = more[0].classList.contains("open");
        buttons.forEach(b => b.textContent = isOpen ? "See Less" : "See More");
    }));

})